<h2 class="title-logo">
  <img [ngClass]="{'large': size === 'large'}" src="../../../assets/img_eugen_logo_home.svg" />
</h2>
